export function getSingleValueLabel<T>(
  value: T[] = [],
  options: { value: T; label: string }[],
  fallbackLabel?: string
): string | undefined {
  if (value.length === 1) {
    const found = options.find((option) => option.value === value[0]);
    return found?.label ?? fallbackLabel;
  }
  return fallbackLabel;
}
